module.exports = __webpack_public_path__ + "static/media/career_tab_1.fd3b7e95.png";